export default "__VITE_ASSET__afb94988__"